function communicate(action, data = null) {
    if (!data) {
        data = {};
    }

    window.top.postMessage({
        combinr: true,
        action,
        ...data,
    }, '*');
}

export function requestRepositioning(block) {
    communicate('position', {block});
}
